import request from '@/utils/request';

export function getExecutionRecord(values) {
  return request('/decision/execute/records', {
    method: 'GET',
    params: values,
  });
}
